function getEnumValues(model, cxt) {
  return model.enum.map(val => ({
    value: val,
    name: cxt.i18n.t(`values.${val}`, val)
  }));
}
export default {
  getEnumValues
};